<div class="card">
    <div class="card-body">
        <kendo-stepper #stepper [steps]="steps" stepType="full" [(currentStep)]="currentStep">
        </kendo-stepper>
        <div class="k-form">
            <app-separation *ngIf="currentStep === 0"></app-separation>
            <app-lone-status *ngIf="currentStep === 1 && separationId" [separationId]="separationId"></app-lone-status>
            <app-status-tracking *ngIf="currentStep === 2 && separationId"
                [separationId]="separationId"></app-status-tracking>
            <app-access-revocation *ngIf="currentStep === 3 && separationId"
                [separationId]="separationId">
            </app-access-revocation>
            <app-exit-clearance *ngIf="currentStep === 4 && separationId"
                [separationId]="separationId"></app-exit-clearance>
            <app-final-settlement *ngIf="currentStep === 5 && separationId"
                [separationId]="separationId"></app-final-settlement>
            <app-document-download *ngIf="currentStep === 6 && separationId"
                [separationId]="separationId"></app-document-download>

            <span class="k-form-separator"></span>
            <div class="d-flex justify-content-between align-items-center mt-3">
                <div>
                    <button class="btn btn-secondary btn-sm"
                        [routerLink]="separationType === 'RESIGNATION' ? '/separation/separation-list' : '/separation/separation-approval-list'"
                        title="Go Back">
                        <i class="bx bx-arrow-back"></i>
                    </button>
                </div>
                <div class="d-flex align-items-center">
                    <span *ngIf="context.persona === 'EMPLOYEE'" class="me-3">Step {{ currentStep + 1 }} of 3</span>
                    <span *ngIf="context.persona === 'HR'" class="me-3">Step {{ currentStep + 1 }} of 7</span>
                    <button class="btn btn-secondary me-2" *ngIf="currentStep !== 0" (click)="prev()">
                        <ng-container *ngIf="inProgress?.value!='true'">
                            <i class='bx bx-skip-previous'></i>
                        </ng-container>
                        Previous
                    </button>
                    <button class="btn btn-secondary" (click)="next()" *ngIf="currentStep !== 6">
                        <ng-container>
                            <i class="bx bx-save"></i>{{ saveOrNextButtonLabel }}
                        </ng-container>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>